export function getTranslation(lang: string): {
    branchDetails: string;
    scheduleAppointment: string;
    lobbyHours: string;
    driveUpHours: string;
    findABranch: string;
    branchTypeErrorDefaultHeader: string;
    branchTypeErrorBranchHeader: string;
    branchTypeErrorAtmHeader: string;
    branchTypeErrorPartnerHeader: string;
    branchTypeErrorSpanishHeader: string;
    branchTypeErrorAtmSubHeader: string;
    branchTypeErrorPartnerSubHeader: string;
    branchTypeErrorSpanishSubHeader: string;
    mountainAmericaBranches: string;
    mountainAmericaAtms: string;
    mountainAmericaPartners: string;
    mountainAmericaSaturdays: string;
    mountainAmericaSpanish: string;
    search: string;
    miles: string;
    allResults: string;
    loadMore: string;
    useCurrentLocation: string;
    cityStateZip: string;
    closed: string;
    opens: string;
    open: string;
    estimatedWait: string;
    lobbyClosed: string;
    driveThruOpen: string;
} {

    const translationStrings = {
        en: {
            branchDetails: 'Branch Details',
            scheduleAppointment: 'Schedule appointment',
            lobbyHours: 'Lobby Hours',
            driveUpHours: 'Drive-up Hours',
            findABranch: 'Find a Branch',
            branchTypeErrorDefaultHeader: 'Enter a search term to find the closest branches or ATMs',
            branchTypeErrorBranchHeader: 'No Mountain America branches were found in this area.',
            branchTypeErrorAtmHeader: 'No Mountain America ATMs were found in this area.',
            branchTypeErrorPartnerHeader: 'No locations were found in this area.',
            branchTypeErrorSpanishHeader: 'No spanish branches were found in this area.',
            branchTypeErrorAtmSubHeader: 'Click here to search for Partner ATMs.',
            branchTypeErrorPartnerSubHeader: 'Please try expanding your search criteria',
            branchTypeErrorSpanishSubHeader: 'Please try expanding your search criteria',
            mountainAmericaBranches: 'All branches',
            mountainAmericaAtms: 'ATMs',
            mountainAmericaPartners: 'Partner ATMs (free)',
            mountainAmericaSaturdays: 'Branches with Saturday hours',
            mountainAmericaSpanish: 'Spanish-speaking branches',
            search: 'Search',
            miles: 'miles',
            allResults: 'All Results',
            loadMore: 'Load More',
            useCurrentLocation: 'Use Current Location',
            cityStateZip: 'City, state, or zip',
            closed: 'Closed',
            opens: 'Opens',
            open: 'Open',
            estimatedWait: 'Est. wait',
            lobbyClosed: 'Lobby closed',
            driveThruOpen: 'Drive-thru open',
        },
        es: {
            branchDetails: 'Detalles de la sucursal',
            scheduleAppointment: 'Programar una cita',
            lobbyHours: 'Horario de oficina',
            driveUpHours: 'Horario de ventanilla',
            findABranch: 'Buscar una sucursal',
            branchTypeErrorDefaultHeader: 'Ingrese un término de búsqueda para encontrar las sucursales o cajeros automáticos más cercanos',
            branchTypeErrorBranchHeader: 'No se encontraron sucursales de Mountain America en esta área.',
            branchTypeErrorAtmHeader: 'No se encontraron cajeros automáticos de Mountain America en esta área.',
            branchTypeErrorPartnerHeader: 'No se encontraron ubicaciones en esta área.',
            branchTypeErrorSpanishHeader: 'No se encontraron sucursales en español en esta área.',
            branchTypeErrorAtmSubHeader: 'Haga clic aquí para buscar cajeros automáticos asociados.',
            branchTypeErrorPartnerSubHeader: 'Intente ampliar sus criterios de búsqueda.',
            branchTypeErrorSpanishSubHeader: 'Intente ampliar sus criterios de búsqueda.',
            mountainAmericaBranches: 'Todas las sucursales',
            mountainAmericaAtms: 'Cajeros automáticos',
            mountainAmericaPartners: 'Cajeros automáticos asociados (gratis)',
            mountainAmericaSaturdays: 'Sucursales con horario de sábado',
            mountainAmericaSpanish: 'Sucursales de habla hispana',
            search: 'Buscar',
            miles: 'millas',
            allResults: 'Todos los resultados',
            loadMore: 'Cargar más',
            useCurrentLocation :'Usar ubicación actual',
            cityStateZip: 'Ciudad, estado o código postal',
            closed: 'Cerrado',
            opens: 'Abre',
            open: 'Abierto',
            estimatedWait: 'Espera aprox.',
            lobbyClosed: 'Oficina cerrada',
            driveThruOpen: 'Ventanilla abierta',
        },
    }
    return translationStrings[lang];
}
